import View from "../common/views/VideoPlayerView";
import components from "./components.js";
components.define("js-VideoPlayer", View);